import { render } from "./FilterRoomReactive.vue?vue&type=template&id=45f5e3d8&scoped=true"
import script from "./FilterRoomReactive.vue?vue&type=script&lang=js"
export * from "./FilterRoomReactive.vue?vue&type=script&lang=js"

import "./FilterRoomReactive.vue?vue&type=style&index=0&id=45f5e3d8&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f5e3d8"]])

export default __exports__